import React, { useEffect, useMemo, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  MenuItem,
  IconButton,
  Dialog,
  FormControlLabel,
  Checkbox,
  useTheme,
  useMediaQuery,
  DialogContent,
  DialogActions,
  DialogContentText,
  Autocomplete,
  TablePagination,
} from "@mui/material";
import {
  useDeleteCustomerMutation,
  useGetCustomerFilterByPerentTableQuery,
  useGetClientTypeQuery,
} from "../../../Api/attoDeskApi";
import {
  IClientType,
  ICustomer,
  IPolicy,
} from "../../../Api/Interface/api.interface";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import { formatPhoneNumberForDisplay } from "../../../Components/Validation/validationUtils";
import {
  DataGrid,
  GridColDef,
  GridPagination,
  GridPaginationModel,
  GridRenderCellParams,
  GridRowSelectionModel,
  GridToolbar,
} from "@mui/x-data-grid";
import NewPopUpCustomer from "../Edit/index";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import CloseIcon from "@mui/icons-material/Close";
import TableViewIcon from "@mui/icons-material/TableView";
import * as XLSX from "xlsx";
import {
  ClientSource,
  ClientStatus,
  ClientType,
  Gender,
  MaritalStatus,
} from "../../../Core/Enum/enum";
import dayjs from "dayjs";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

function getGenderLabel(genderId: string) {
  switch (genderId) {
    case Gender.Male:
      return "Male";
    case Gender.Female:
      return "Female";
    case Gender.Other:
      return "Other";
    default:
      return "";
  }
}

function getInsuranceClient(customerClientId: string) {
  switch (customerClientId) {
    case ClientType.InsuranceClient:
      return "Insurance Client";
    case ClientType.RealstatesClient:
      return "Real estate Client";
    default:
      return "";
  }
}

function getMaritalStatusLabel(maritalStatusId: string) {
  switch (maritalStatusId) {
    case MaritalStatus.Single:
      return "Single";
    case MaritalStatus.Married:
      return "Married";
    case MaritalStatus.Divorced:
      return "Divorced";
    case MaritalStatus.Widowed:
      return "Widowed";
    default:
      return "";
  }
}

function getClientStatus(customerClientStatusId: string) {
  switch (customerClientStatusId) {
    case ClientStatus.Active:
      return "Active";
    case ClientStatus.Inactive:
      return "Inactive";
    case ClientStatus.Pending:
      return "Pending";
    case ClientStatus.Closed:
      return "Closed";
    default:
      return "";
  }
}

function getClientSource(customerClientSource: string) {
  switch (customerClientSource) {
    case ClientSource.Referral:
      return "Referral";
    case ClientSource.Website:
      return "Website";
    case ClientSource.WalkIn:
      return "WalkIn";
    case ClientSource.CallCenter:
      return "CallCenter";
    case ClientSource.Email:
      return "Email";
    case ClientSource.SocialMedia:
      return "SocialMedia";
    default:
      return "";
  }
}

const toAllCaps = (text: string | null | undefined): string => {
  if (!text) return "";
  return text.toUpperCase();
};

const allColumns = [
  "Client Id",
  "Client Type",
  "Client Name",
  "Cell Phone Number",
  "Work Phone Number",
  "E-mail",
  "Address",
  "Gender",
  "Marital Status",
  "Date Of Birth",
  "Prefer Time to Call",
  "Client Status",
  "Client Source",
  "Contact Stage",
  "Referred By",
];

interface CustomerOption {
  label: string;
  value: number;
}

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 100,
  });
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedCoursing, setSelectedCoursing] = useState<ICustomer | null>(
    null
  );
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<ICustomer | null>(
    null
  );

  const [selectedIsBooked, setSelectedProductIsBooked] =
    useState<string>("AllType");
  const [selectedClient, setSelectedClient] = useState<string>("all");
  const [selectedClientCat, setSelectedClientCat] = useState<string>("All");
  const [selectedClientPerent, setSelectedClientPerent] =
    useState<string>("policyOwner");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [policyData, setPolicyData] = useState<IPolicy[]>([]);
  const [isOwnPolicy, setIsOwnPolicy] = useState<string>("");
  const [message, setMessage] = useState("");
  const [selectedColumns, setSelectedColumns] = useState<string[]>([]);
  const [selectedRowIds, setSelectedRowIds] = useState<GridRowSelectionModel>(
    []
  );

  const { data: clientData, isLoading: cilentIsLoading } =
    useGetClientTypeQuery({
      searchText: "",
      id: "",
    });

  const handleOpen = () => {
    setSelectedColumns(allColumns);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handleOpen1 = () => {
    setOpen1(true);
  };
  const handleClose1 = () => setOpen1(false);

  const { data, isLoading, isError, refetch } =
    useGetCustomerFilterByPerentTableQuery({
      searchText: currentSearchQuery,
      id: "",
      isPolicyOwnAndBenifiOnly: selectedClientPerent,
      customerClientId: selectedClient,
    });

  // const { data, isLoading, isError, refetch } =
  //   useGetCustomerFilterByPerentTableQuery({
  //     searchText: currentSearchQuery,
  //     id: "",
  //     // isParent: selectedIsBooked,
  //     isParentFilter: selectedClientCat,
  //     isPerent: selectedClientPerent,
  //     isParent:
  //       selectedIsBooked && selectedIsBooked !== "AllType"
  //         ? selectedIsBooked
  //         : "",
  //     customerClientId: selectedClient,
  //   });

  // const handleChangePage = (event: unknown, newPage: number) => {
  //   setPage(newPage);
  // };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleCheckboxChange = (column: string) => {
    setSelectedColumns((prev) =>
      prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column]
    );
  };

  const cliendList = useMemo(() => {
    return (clientData?.data ?? []) as IClientType[];
  }, [clientData?.data]);

  const clientTypeMap = useMemo(() => {
    const map = new Map();
    cliendList?.forEach((category) => {
      map.set(category.id, category.client_type);
    });
    return map;
  }, [cliendList]);

  const handleSelectAllChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setSelectedColumns(allColumns);
    } else {
      setSelectedColumns([]);
    }
  };

  const handleOpenDialog = (coursing: ICustomer) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: ICustomer) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteCustomerMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        setMessage(response.message);
        setPolicyData(response.data);
        setIsOwnPolicy(response.isOwnPolicy);
        console.log("isOwnPolicy:", response.isOwnPolicy);
        setOpen1(true);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the Client");
    }
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: ICustomer[] = Array.isArray(data?.data)
    ? (data?.data as ICustomer[])
    : [];

  const handleAddProductClick = () => {
    navigate("/customer/create");
  };

  const handleIsBooked = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    if (selectedValue === "all") {
      setSelectedProductIsBooked("");
    } else {
      setSelectedProductIsBooked(selectedValue);
    }
  };

  const handleIsClient = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedClient(selectedValues);
  };

  const handleIsClientCat = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedClientCat(selectedValues);
  };

  const handleIsClientPerent = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedClientPerent(selectedValues);
  };

  const columns: GridColDef[] = [
    {
      field: "customerRefId",
      headerName: "Client Id",
      minWidth: 180,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        const customerRefId = params.row.customerRefId;

        // If customerRefId is null or empty, just return plain text
        if (!customerRefId) {
          return <span></span>;
        }

        return (
          <Link
            to={`/profile/customer/${params.row.id}`}
            className={classes.iconLinkPropNormal}
          >
            <span
              style={{
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
              }}
              // onClick={() => navigate(`/profile/customer/${params.row.id}`)}
            >
              {customerRefId}
              <FontAwesomeIcon icon={faLink} style={{ color: "#1976d2" }} />
            </span>
          </Link>
        );
      },
    },
    {
      field: "customerName",
      headerName: "Client Name",
      minWidth: 200,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Link
          to={`/profile/customer/${params.row.id}`}
          className={classes.iconLinkPropNormal}
        >
          <span
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
            // onClick={() => navigate(`/profile/customer/${params.row.id}`)}
          >
            {`${toProperCase(params.row.customerFirstName)} ${toProperCase(
              params.row.customerLastName
            )}`}
            <FontAwesomeIcon icon={faUser} style={{ color: "#1976d2" }} />
          </span>
        </Link>
      ),
    },
    {
      field: "customerMobileNum",
      headerName: "Mobile Number",
      minWidth: 200,
      flex: 1,
      renderCell: (params: GridRenderCellParams) =>
        formatPhoneNumberForDisplay(params.row.customerMobileNum),
    },
    {
      field: "customerEmail",
      headerName: "E-mail",
      minWidth: 200,
      flex: 1,
    },
    // {
    //   field: "customerClientId",
    //   headerName: "Type of Client",
    //   flex: 1,
    //   renderCell: (params: GridRenderCellParams) =>
    //     getInsuranceClient(params.row.customerClientId),
    // },
    {
      field: "customerAddress",
      headerName: "Address",
      minWidth: 300,
      flex: 1,
      //   headerAlign: "center",
      // align: "center",
      renderCell: (params: GridRenderCellParams) => (
        <div>
          {/* {capitalizeFirstLetter(params.row.customerAddresLine)}{" "}
          {capitalizeFirstLetter(params.row.customerCity)}
          {capitalizeFirstLetter(params.row.customerProvince)}{" "}
          {capitalizeFirstLetter(params.row.customerPostalCode)} */}
          {[
            toProperCase(params.row.customerAddresLine),
            toProperCase(params.row.customerCity),
            // capitalizeFirstLetter(params.row.customerProvince),
            // capitalizeFirstLetter(params.row.customerPostalCode),
          ]
            .filter(Boolean)
            .join(" , ")}{" "}
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 300,
      flex: 1,
      headerClassName: classes.tablheader200,
      headerAlign: "right",
      renderCell: (params: GridRenderCellParams) => (
        <div>
          <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              textAlign: "center",
              alignItems: "center",
              alignContent: "center",
            }}
          >
            <Grid item>
              <Link
                to={`/profile/customer/${params.row.id}`}
                className={classes.iconLinkPropNormal}
              >
                <IconButton
                  // variant="contained"
                  className={classes.viewButtonListGridTable}
                  onClick={() => navigate(`/profile/customer/${params.row.id}`)}
                >
                  <VisibilitySharpIcon className={classes.viewListIcon} />
                </IconButton>
              </Link>
            </Grid>
            <Grid item>
              <IconButton
                // variant="contained"
                className={classes.editButtonListGridTable}
                onClick={() => handleOpenDialog(params.row)}
              >
                <EditSharpIcon className={classes.editListIcon} />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                // variant="contained"
                className={classes.deleteButtonListGridTable}
                onClick={() => handleOpenDeletePopup(params.row)}
              >
                <DeleteOutlineSharpIcon className={classes.deleteListIcon} />
              </IconButton>
            </Grid>
          </Grid>
        </div>
      ),
    },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   minWidth: 300,
    //   flex: 1,
    //   headerClassName: classes.tablheader200,
    //   headerAlign: "right",
    //   renderCell: (params: GridRenderCellParams) => (
    //     <div>
    //       <IconButton
    //         // variant="contained"
    //         // className={classes.viewButtonList}
    //         onClick={() => navigate(`/profile/customer/${params.row.id}`)}
    //       >
    //         <VisibilitySharpIcon className={classes.viewListIcon} />
    //       </IconButton>

    //       {/* <Button
    //         variant="contained"
    //         className={classes.editButtonList}
    //         onClick={() => handleOpenDialog(params.row)}
    //       >
    //         <EditSharpIcon className={classes.editListIcon} />
    //       </Button>

    //       <Button
    //         variant="contained"
    //         className={classes.deleteButtonList}
    //         onClick={() => handleOpenDeletePopup(params.row)}
    //       >
    //         <DeleteOutlineSharpIcon className={classes.deleteListIcon} />
    //       </Button> */}
    //     </div>
    //   ),
    // },
  ];

  const formattedRows = coursings.map((row: ICustomer) => ({
    id: row.id,
    customerRefId: row.customerRefId,
    customerFirstName: row.customerFirstName,
    customerLastName: row.customerLastName,
    customerMobileNum: row.customerMobileNum,
    customerEmail: (row.customerEmail || "").trim().toLowerCase(),
    // customerClientId: row.customerClientId,
    customerAddresLine: row.customerAddresLine,
    customerCity: row.customerCity,
    customerProvince: row.customerProvince,
    customerPostalCode: row.customerPostalCode,
  }));

  const handleRowSelection = (selectionModel: GridRowSelectionModel) => {
    setSelectedRowIds(selectionModel);
  };

  const handleExport = () => {
    handleExportExcel(selectedColumns);
    handleClose();
  };

  const handleExportExcel = (selectedCols: string[]) => {
    const coursings: ICustomer[] = Array.isArray(data?.data)
      ? (data?.data as ICustomer[])
      : [];

    const selectedRows = coursings.filter((row) =>
      selectedRowIds.includes(row.id)
    );

    if (selectedRows.length === 0) {
      alert("Please select at least one row to export!");
      return;
    }
    const fullExcelData = selectedRows.map((row) => ({
      "Client Id": row.customerRefId || "",
      "Client Type": clientTypeMap.get(Number(row.customerClientId)) || "",
      "Client Name":
        `${toProperCase(row.customerFirstName || "")} ${toProperCase(
          row.customerLastName || ""
        )}`.trim() || "",
      "Work Phone Number":
        formatPhoneNumberForDisplay(row.customerWorkMobileNum) || "",
      "Home Phone Number":
        formatPhoneNumberForDisplay(row.customerHomeMobileNum) || "",
      "Cell Phone Number":
        formatPhoneNumberForDisplay(row.customerMobileNum) || "",
      "E-mail": (row.customerEmail || "").toLowerCase() || "",
      Address:
        [
          toProperCase(row.customerAddresLine || ""),
          toProperCase(row.customerCity || ""),
          toAllCaps(row.customerProvince || ""),
          toAllCaps(row.customerPostalCode || ""),
        ]
          .filter(Boolean)
          .join(", ") || "",
      "Date Of Birth": row.customerDateOfBirth
        ? dayjs(row.customerDateOfBirth).format("MMM D, YYYY")
        : "",
      Gender: row.customerGenderId ? getGenderLabel(row.customerGenderId) : "",
      "Marital Status": row.customerMaritalStatusId
        ? getMaritalStatusLabel(row.customerMaritalStatusId)
        : "",
      "Prefer Time to Call":
        capitalizeFirstLetter(row.customerPreferTimeToCall || "") || "",
      "Client Status": row.customerClientStatusId
        ? getClientStatus(row.customerClientStatusId)
        : "",
      "Client Source": row.customerClientSource
        ? getClientSource(row.customerClientSource)
        : "",
      "Contact Stage": capitalizeFirstLetter(row.customerContactStage || ""),
      "Referred By": capitalizeFirstLetter(row.customerHeight || ""),
    }));

    const filteredExcelData = fullExcelData.map((row) => {
      const filteredRow: any = {};
      selectedCols.forEach((col) => {
        filteredRow[col] = row[col as keyof typeof row];
      });
      return filteredRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredExcelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Client");
    const today = dayjs();
    const formattedDate = today.format("MMM, DD YYYY (dddd)");
    const filename = `Client_${formattedDate}.xlsx`;
    XLSX.writeFile(workbook, filename);
  };

  const isAllSelected = selectedColumns.length === allColumns.length;

  const totalRows = formattedRows.length;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPaginationModel((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = parseInt(event.target.value, 10);
    setPaginationModel({ page: 0, pageSize: value });
  };

  return (
    <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
            <Grid item lg={3} md={4} sm={12} xs={12}>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Mobile & Name .."
                size="small"
                className={classes.searchTextField}
              />
            </Grid>
            <Grid item>
              <TextField
                select
                size="small"
                sx={{ flexGrow: 1, width: "100%" }}
                value={selectedClientPerent || ""}
                onChange={handleIsClientPerent}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  classes: {
                    root: classes.formControlListStatus,
                  },
                }}
                className={classes.searchTextField34}
              >
                <MenuItem value="policyOwner">Policy Owner</MenuItem>
                <MenuItem value="Insured">Insured</MenuItem>
                {/* <MenuItem value="policyOwnerandInsured">
                  policy Owner and Insured
                  All Clients
                </MenuItem> */}
                <MenuItem value="Beneficiary">Beneficiary</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
                <MenuItem value="all">All</MenuItem>
              </TextField>
            </Grid>
            {/* <Grid item>
              <TextField
                select
                size="small"
                sx={{ flexGrow: 1, width: "100%" }}
                value={selectedClientCat || ""}
                onChange={handleIsClientCat}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  classes: {
                    root: classes.formControlListStatus,
                  },
                }}
                className={classes.searchTextField34}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="parent">Parent</MenuItem>
                <MenuItem value="child">Child</MenuItem>
              </TextField>
            </Grid> */}
            <Grid item>
              <TextField
                select
                size="small"
                sx={{ flexGrow: 1, width: "100%" }}
                value={selectedClient || ""}
                onChange={handleIsClient}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  classes: {
                    root: classes.formControlListStatus,
                  },
                }}
                className={classes.searchTextField34}
              >
                <MenuItem value="all">All Client Types</MenuItem>
                {cliendList &&
                  cliendList.map((category) => (
                    <MenuItem key={category.id} value={category.id}>
                      {category.client_type}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid item>
              <Button
                // variant="contained"
                startIcon={<TableViewIcon />}
                className={classes.addNewButton}
                onClick={handleOpen}
                disabled={selectedRowIds.length === 0}
              >
                Export to Excel
              </Button>
            </Grid>
            <Grid item>
              <Link
                to={`/customer/create`}
                className={classes.iconLinkPropNormal}
              >
                <Button
                  // variant="contained"
                  className={classes.addNewButton}
                  onClick={handleAddProductClick}
                >
                  Add Client
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <Grid
          item
          sx={{ width: "100%", pb: 5, borderTop: 2, pt: 2 }}
          className={classes.titleGrid}
        >
          <div style={{ width: "100%" }}>
            <TablePagination
              component="div"
              count={formattedRows.length}
              page={paginationModel.page}
              onPageChange={handleChangePage}
              rowsPerPage={paginationModel.pageSize}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50, 100, formattedRows.length]}
            />

            <DataGrid
              rows={formattedRows.slice(
                paginationModel.page * paginationModel.pageSize,
                (paginationModel.page + 1) * paginationModel.pageSize
              )}
              columns={columns}
              getRowId={(row) => row.id}
              autoHeight
              rowHeight={60}
              checkboxSelection
              disableRowSelectionOnClick
              className={classes.dataGridTable}
              onRowSelectionModelChange={handleRowSelection}
              hideFooter
            />
          </div>

          {/* <DataGrid
            rows={formattedRows}
            columns={columns}
            getRowId={(row) => row.id}
            autoHeight
            pagination
            initialState={{
              pagination: { paginationModel: { pageSize: 100 } },
            }}
            rowHeight={60}
            pageSizeOptions={[5, 10, 20, 50, 100]}
            style={{ height: "100%", width: "100%" }}
            className={classes.dataGridTable}
            checkboxSelection
            disableRowSelectionOnClick
            onRowSelectionModelChange={handleRowSelection}
          /> */}
        </Grid>

        {selectedCoursing && (
          <NewPopUpCustomer
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedCoursing}
          />
        )}
        {coursingToDelete && (
          <DeletePopup
            open={openDeleteCategory}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(coursingToDelete.id.toString());
            }}
            title="Delete Client"
            content={`Are you sure you want to delete "${
              coursingToDelete.customerFirstName +
              " " +
              coursingToDelete.customerLastName
            }"?`}
          />
        )}
      </Grid>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-describedby="alert-dialog-description"
        classes={{ paper: "inherit" }}
        fullScreen={isMobile}
        fullWidth={isMobile}
        maxWidth="lg"
      >
        <Grid className={classes.Dialog}>
          <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Select Columns to Export
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"24px"}>
                      <Grid container spacing={3} p={"24px"}>
                        <>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isAllSelected}
                                  indeterminate={
                                    selectedColumns.length > 0 && !isAllSelected
                                  }
                                  onChange={handleSelectAllChange}
                                />
                              }
                              label="Select All"
                            />
                          </Grid>

                          {allColumns.map((column) => (
                            <Grid
                              item
                              lg={3}
                              md={3}
                              sm={12}
                              xs={12}
                              key={column}
                            >
                              <FormControlLabel
                                key={column}
                                control={
                                  <Checkbox
                                    checked={selectedColumns.includes(column)}
                                    onChange={() =>
                                      handleCheckboxChange(column)
                                    }
                                  />
                                }
                                label={column}
                              />
                            </Grid>
                          ))}
                        </>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={handleClose}
                        >
                          Cancel
                        </Button>
                        <Box m={0.5}></Box>

                        <Button
                          variant="contained"
                          startIcon={<TableViewIcon />}
                          className={classes.addButton}
                          onClick={handleExport}
                          disabled={selectedColumns.length === 0}
                        >
                          Export
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={open1}
        onClose={handleClose1}
        sx={{ padding: 5, minWidth: 450 }}
      >
        <Grid className={classes.Dialog}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              pt={2}
              alignContent={"center"}
            >
              <Typography className={classes.cardTitle}>Alert</Typography>
            </Grid>
          </Grid>
          <DialogContent>
            <DialogContentText sx={{ pt: 3, fontSize: "15px" }}>
              {message}
            </DialogContentText>

            {policyData.length > 0 && (
              <ul style={{ paddingLeft: "1.5rem" }}>
                {policyData.map((policy, idx) => (
                  <li key={idx}>
                    <Button
                      variant="text"
                      onClick={() => {
                        if (isOwnPolicy === "yes") {
                          navigate(
                            `/customer/${policy.policyCustomerId}/policy/${policy.policyNumber}`
                          );
                        } else if (isOwnPolicy === "no") {
                          navigate(`/coverage/deal/${policy.id}`);
                        }
                      }}
                      sx={{
                        textTransform: "none",
                        padding: 0,
                        minWidth: "auto",
                      }}
                    >
                      {policy.policyNumber}
                    </Button>
                  </li>
                ))}
              </ul>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleClose1();
                setOpenDeleteCategory(false);
              }}
              variant="contained"
              startIcon={<CheckCircleOutlineIcon />}
              className={classes.addButton}
            >
              okay
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
    </Card>
  );
};

export default Index;
